import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'success' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}

/**
 * Button component with dark mode styling
 * Variants: primary (blue), secondary (gray), success (green), danger (red)
 * Minimum height: 44px for touch targets
 */
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'font-medium rounded-lg transition-colors min-h-[44px] disabled:opacity-50 disabled:cursor-not-allowed';
  
  const variantStyles = {
    primary: 'bg-primary-blue text-white hover:bg-blue-600 active:bg-blue-700',
    secondary: 'bg-muted-text text-white hover:bg-gray-700 active:bg-gray-800',
    success: 'bg-success text-white hover:bg-green-500 active:bg-green-600',
    danger: 'bg-error text-white hover:bg-red-500 active:bg-red-600',
  };
  
  const sizeStyles = {
    sm: 'py-2 px-4 text-sm',
    md: 'py-3 px-6 text-base',
    lg: 'py-4 px-8 text-lg',
  };
  
  const widthStyles = fullWidth ? 'w-full' : '';
  
  const classes = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${widthStyles} ${className}`.trim();
  
  return (
    <button className={classes} disabled={disabled} {...props}>
      {children}
    </button>
  );
}












